import React from "react";
import { withRouter } from "react-router-dom";
import { Typography, Badge } from "../Wrappers/Wrappers";

import { useSelector } from 'react-redux';

// styles
import useStyles from "./styles";
import { pathOr, path } from "ramda";


function BrandLogo(props) {
    const classes = useStyles();
    const config = useSelector((state) => state.config);

    const currentThemeLogo = pathOr('simpleX', ['themeConfig', 'currentTheme'], config) === "dark" ? "logo_image_dark" : "logo_image";

    const brandLogo = pathOr(pathOr('', ['config', 'logo_image'], config),
        ['config', currentThemeLogo],
        config);
    // console.log("brandLogo0000000", brandLogo)

    return (
        <div >
            {brandLogo ? (
                <div className={classes.logoBox}>
                    <div>
                        <img
                            src={brandLogo}
                            onError={() => console.log("Something went wrong!!!")}
                            alt="brand-name"
                            style={{ objectFit: "contain", width: "120px" }}
                        />
                    </div>
                    {/* <em className={classes.version}>v3.0.0</em> */}

                </div>
            ) : (
                    <div className={classes.logoBox}>
                        <div className={classes.logotype}>
                            {process.env.REACT_APP_BRAND_NAME}

                        </div>
                        <em className={classes.version}>v3.0.0</em>

                    </div>
                )}
        </div>
    );
}

export default withRouter(BrandLogo);
